import React, { useEffect, useState } from "react";
import { UseAxios } from '../Server-Api-Instance.js';
import {
    TextField, Box, Grid, Button, MenuItem, Table, TableHead,
    TableBody, TableCell, TableContainer, TableRow, Paper
} from '@mui/material';
import { ThemeProvider } from '@mui/material';
import theme from '../Shared/theme.js';
import '../Shared/CommonStyle.css';
import { TableFooter } from '@mui/material';
import { Select,  FormControl, InputLabel } from '@mui/material';

const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2021 + 1 }, (_, i) => currentYear+2 - i);

const PackageSummaryTable = ({ username }) => {
    const [data, setData] = useState([]);
    const [month, setMonth] = useState('All');
    const [year, setYear] = useState(new Date().getFullYear());
    const [loading, setLoading] = useState(false);

    const months = [
        { label: 'All Months', value: 'All' },
        { label: 'January', value: 1 }, { label: 'February', value: 2 },
        { label: 'March', value: 3 }, { label: 'April', value: 4 },
        { label: 'May', value: 5 }, { label: 'June', value: 6 },
        { label: 'July', value: 7 }, { label: 'August', value: 8 },
        { label: 'September', value: 9 }, { label: 'October', value: 10 },
        { label: 'November', value: 11 }, { label: 'December', value: 12 },
    ];
    const fetchData = async (selectedYear = year, selectedMonth = month) => {
        if (!username) return;
        setLoading(true);

        try {
            const axios = UseAxios(false);
            const payload = {
                username,
                year: parseInt(selectedYear),
                month: selectedMonth === 'All' ? 0 : parseInt(selectedMonth),
            };

            const response = await axios.post('/GetAgentPackagereport', payload);
            setData(response.data || []);
        } catch (error) {
            console.error('Error fetching data:', error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchData();
    }, [username]);

    const handleFilter = () => {
        fetchData();
    };
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 2,
        }).format(value || 0).replace('£', '£');
    };

    const totalPax = data.reduce((sum, row) => sum + Number(row.Pax || 0), 0);
    const totalBookings = data.reduce((sum, row) => sum + Number(row.Bookings || 0), 0);
    const totalSell = data.reduce((sum, row) => sum + parseFloat(row.TotalSell || 0), 0);
    const totalComm = data.reduce((sum, row) => sum + parseFloat(row.AgencyCommission || 0), 0);

    return (
        <ThemeProvider theme={theme}>
            <Box className="header">
                <Box className="heading-box">BOOKING DETAILS</Box>

                <Grid container spacing={2} >

                    <Grid item xs={6} sm={4}>
                    <FormControl fullWidth>
  <InputLabel id="departure-year-label">Departure Year</InputLabel>
  <Select
    labelId="departure-year-label"
    value={year}
    label="Departure Year"
    onChange={(e) => setYear(e.target.value)}
  >
    {years.map((yr) => (
      <MenuItem key={yr} value={yr}>
        {yr}
      </MenuItem>
    ))}
  </Select>
</FormControl>

                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <TextField
                            label="Departure Month"
                            select
                            fullWidth
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        >
                            {months.map((m) => (
                                <MenuItem key={m.value} value={m.value}>
                                    {m.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>


                    <Grid item xs={12} sm={4}>
                        <Button className="fetch-button"
                            variant="contained"
                            fullWidth
                            style={{ backgroundColor: '#BE9F55', color: '#fff', marginTop: '4px' }}
                            onClick={handleFilter}
                        >
                            SUBMIT
                        </Button>
                    </Grid>
                </Grid>

                {loading ? (
                    <Box className="loading-message">Loading data...</Box>
                ) : (
                    <Box sx={{
                       
                     
                        mt: 1,
                        border: '1px solid #BE9F55;',
                        borderRadius: '2px'
                    }}>
                        <TableContainer sx={{ maxHeight: 410 }} >
                            <Table stickyHeader>

                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#bea05a',backgroundColor: "#BE9F55" }}>
                                        <TableCell  style={{ backgroundColor: '#bea05a',color: 'white',fontWeight:'bold' }}>Package Type</TableCell>
                                        <TableCell style={{backgroundColor: '#bea05a',color: 'white',fontWeight:'bold' }}>No. PAX</TableCell>
                                        <TableCell style={{backgroundColor: '#bea05a',color: 'white',  fontWeight:'bold'  }}>No. BKGS</TableCell>
                                        <TableCell style={{backgroundColor: '#bea05a',color: 'white', width:'130px', fontWeight:'bold' }}>Sell Amount</TableCell>
                                        <TableCell style={{backgroundColor: '#bea05a',color: 'white', width:'130px', fontWeight:'bold' }}>Agency Comm </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell >{row.Category}</TableCell>
                                            <TableCell >{row.Pax || 0}</TableCell>
                                            <TableCell>{row.Bookings || 0}</TableCell>
                                            <TableCell >{formatCurrency(row.TotalSell)}</TableCell>
                                            <TableCell>{formatCurrency(row.AgencyCommission)}</TableCell>
                                        </TableRow>
                                    ))}

                                </TableBody>
                                <TableFooter>
                                    <TableRow className="sticky-footer"   >
                                        <TableCell style={{ fontSize: '13px', fontWeight: 'bold' }}>Total</TableCell>
                                        <TableCell style={{ fontSize: '13px', fontWeight: 'bold' }}>{totalPax}</TableCell>
                                        <TableCell style={{ fontSize: '13px', fontWeight: 'bold' }}>{totalBookings}</TableCell>
                                        <TableCell style={{ fontSize: '13px', fontWeight: 'bold' ,  color: 'blue',}}>{formatCurrency(totalSell.toFixed(2))}</TableCell>
                                        <TableCell style={{ fontSize: '13px', fontWeight: 'bold',  color: 'green', }}>{formatCurrency(totalComm.toFixed(2))}</TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </Box>
                )}
            </Box>
        </ThemeProvider>
    );
};

export default PackageSummaryTable;
